import React from "react";
import MessageWrapper from "./MessageWrapper";
import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";
import OfferIcon from "@components/icons/Offer";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

interface CustomMessageProps {
	customMessageData: any;
	isLink?: boolean;
	isMultiOffer?: boolean;
}

const CustomMessage = ({
	customMessageData,
	isLink,
	isMultiOffer,
}: CustomMessageProps) => {
	const { chatViewStore } = useRootAppStore();
	const { t } = useTranslation("mybets");

	const sharedSlipData =
		customMessageData?.data?.betSlipData ||
		customMessageData?.data?.sharedSlip;
	const message = customMessageData?.data?.text;

	if (!sharedSlipData) {
		return null;
	}

	const {
		eventCount,
		maxCoefficient,
		dateCreated,
		sportAbrv,
		firstEventName,
		betSlipNumber,
	} = sharedSlipData;

	return (
		<>
			<ErrorBoundaryWithPropagation
				componentName={"Mobile/CustomMessage.tsx"}
			>
				<MessageWrapper isLink={isLink} anchor={message}>
					{message && message != " " && (
						<div className="chat__replying">{message}</div>
					)}
				</MessageWrapper>

				<div
					className="chat__slip"
					onClick={() =>
						chatViewStore.chatBetSlipShareHandler.openChatSharedSlipPopup(
							betSlipNumber
						)
					}
				>
					<div className="chat__slip__header">
						<OfferIcon
							type="sport"
							sport={sportAbrv}
							className="chat__icon__primary u-icon u-icon--lrg"
						/>

						{isMultiOffer && (
							<i className="u-icon u-icon--bb--active u-icon--med"></i>
						)}

						<span className="chat__slip__count">{eventCount}</span>
						<span className="chat__slip__title">
							{firstEventName}
						</span>
					</div>

					<div className="chat__slip__footer">
						<span>
							{t("BET_SLIP.MAX_COEF")}:{" "}
							<strong>{maxCoefficient}</strong>
						</span>
						<span className="u-color--text--tertiary">
							{dateCreated}
						</span>
					</div>
				</div>
			</ErrorBoundaryWithPropagation>
		</>
	);
};

export default CustomMessage;
